module.exports = __webpack_public_path__ + "static/media/naration.40cb0e28.ogg";